







































import {
  CouponItemExtend,
  couponListPageConfigStore,
  getCouponListByPage,
  USEABLE_FLAG,
} from '@/business/couponList';
import { Component, Vue, Watch } from 'vue-property-decorator';
import Coupon from '../../components/coupon-list/coupon.vue';
import VueBetterScroll from 'vue2-better-scroll';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { showBusinessError } from '@tencent/wphk-components-dialog';
import { CustomException } from '@tencent/ppd-base-libs';
import { biHT } from '@/business/bi';
import { Route } from 'vue-router';
import InvalidEntry from './invalid-entry.vue';
import { i18n } from '../../i18n/index';
import { FitLayout, FitWxPhonex } from '@tencent/wphk-ui';
import to from '@/business/to.js';
import { ERouteName } from '@/config';

Component.registerHooks(['beforeRouteEnter']);

// https://hkwallet.moneydata.hk/cgi-bin/app/ewallet_bindcard/ewallet_coupon_index.cgi?page=coupon-list&useable_flag=1&discount_center=1#/coupon-detail?user_coupon_id=2021092760407141800441093124
@Component({
  components: {
    Coupon,
    VueBetterScroll,
    InvalidEntry,
    FitLayout,
    FitWxPhonex,
  },
})
export default class CIndex extends Vue {
  /** 优惠券数据 */
  private coupons: CouponItemExtend[] = [];
  private hasMore = true;
  private loadingDone = false;
  /** 初始上拉分页配置 */
  private initPullUploadConfig = {
    threshold: 0,
    txt: {
      more: ' ',
      noMore: ' ',
    },
  };

  /** 是否展示券列表 */
  private get isShowList() {
    return this.coupons.length > 0;
  }

  private get isInvalidCouponPage() {
    return this.$route.query.type === USEABLE_FLAG.INVALID;
  }

  /**
   * 监听路由来源
   * @param to
   * @param from
   * @param next
   */
  private beforeRouteEnter(to, from, next) {
    // 从抢券过来的直接重定向到商户电子消费券
    if (from?.name === ERouteName.weCouponsList || from?.name === ERouteName.weCouponsSpList) {
      next({
        name: 'displaycouponlist',
        replace: true,
      });
    } else {
      next();
    }
  }

  @Watch('$route', { immediate: true })
  private handleRouteChange(to: Route, from: Route) {
    if (from && from.path === '/couponlist') {
      this.resetPageData();
      couponListPageConfigStore.reset(this.$route.query.type);
      this.fetchCouponList();
      this.setTitleAndHottag();
    }
  }

  private async created() {
    couponListPageConfigStore.reset(this.$route.query.type);
    this.fetchCouponList();
    this.setTitleAndHottag();
  }

  private setTitleAndHottag() {
    document.title = this.isInvalidCouponPage
      ? i18n('已用及失效卡券')
      : i18n('自動扣減券');
    this.isInvalidCouponPage
      ? biHT('wallet.couponlist.expiredpage.brow')
      : biHT('wallet.couponlist.listpage.brow');
  }

  private resetPageData() {
    this.coupons = [];
    this.hasMore = true;
    this.loadingDone = false;
  }

  private updateScrollRef() {
    const scrollRef = this.$refs.scroll;
    scrollRef && (scrollRef as any).forceUpdate(this.hasMore); // false ：加载完了；true:未加载完
  }
  private async fetchCouponList() {
    if (!this.hasMore) {
      // 加载完毕之后，就不触发加载了
      this.updateScrollRef();
    } else {
      showLoading();
      const [err, res] = await to(getCouponListByPage());
      this.loadingDone = true;
      hideLoading();
      if (err) {
        showBusinessError(err);
        throw new CustomException('Fail to fetch couponList', err);
      }
      const { coupons, hasMore } = res;
      this.hasMore = hasMore;
      this.coupons = [...this.coupons, ...coupons];
      this.updateScrollRef();
    }
  }
}
